import type { CollectorSummary } from "../../../src/contracts/admin";

export type CollectorStatePresentation = {
  label: string;
  tone: "success" | "warning" | "danger" | "neutral";
  operational: boolean;
};

export function listCollectorStatePresentation(
  collector: Pick<CollectorSummary, "activation_status" | "last_seen_at" | "access">,
): CollectorStatePresentation {
  if (collector.activation_status === "revoked") {
    return { label: "Revogado", tone: "neutral", operational: false };
  }
  if (collector.activation_status === "pending") {
    return collector.access.activation?.state === "expired"
      ? { label: "Código expirado", tone: "danger", operational: false }
      : { label: "Aguardando ativação", tone: "warning", operational: false };
  }
  const operational = isRecent(collector.last_seen_at);
  return operational
    ? { label: "Reportando", tone: "success", operational: true }
    : { label: "Ativo · sem contato", tone: "warning", operational: false };
}

export function detailCollectorStatePresentation(
  activationStatus: "pending" | "active" | "revoked",
  lastSeenAt: string | null,
): CollectorStatePresentation {
  if (activationStatus === "revoked") {
    return { label: "Revogado", tone: "neutral", operational: false };
  }
  if (activationStatus === "pending") {
    return { label: "Aguardando ativação", tone: "warning", operational: false };
  }
  const operational = isRecent(lastSeenAt);
  return operational
    ? { label: "Reportando", tone: "success", operational: true }
    : { label: "Ativo · sem contato", tone: "warning", operational: false };
}

function isRecent(value: string | null): boolean {
  if (!value) return false;
  const normalized = value.includes("T") ? value : `${value.replace(" ", "T")}Z`;
  return Date.now() - new Date(normalized).getTime() < 5 * 60 * 1000;
}
